<div class="header-container" id="wallet-emails-tab-header">
  <span i18n id="wallet-emails-tab-span-title">Registra tus e-mails para recibir notificaciones</span>
  <button id="wallet-emails-tab-btn-new" class="red-button new-button" (click)="addEmail()" i18n>
    Nuevo e-mail
  </button>
</div>

@if (isAlert30Days && walletEmails.length === 0) {
  <div
    id="wallet-emails-tab-alert-30days"
    class="alert-banner"
    role="alert"
    aria-live="polite"
    data-testid="alert-30-days-email-warning"
    >
    <em class="fas fa-exclamation-triangle" aria-hidden="true" id="wallet-emails-tab-icon-alert"></em>
    <span i18n="@@alert30DaysEmailRequired" id="wallet-emails-tab-span-alert">
    Para o plano Alerta 30 dias, é obrigatório cadastrar ao menos um e-mail para receber notificações.
  </span>
  </div>
}

<div class="table-container" id="wallet-emails-tab-table-container">
  <app-generic-table
    id="wallet-emails-tab-table"
    [config]="tableConfig"
    [data]="walletEmails"
    [isLoading]="isLoading"
    [noDataMessage]="noDataMessage"
    [showPagination]="false"
    >
    <ng-template appTableCell="_status" let-email>
      <mat-slide-toggle
        id="wallet-emails-tab-toggle-status-{{email.id}}"
        labelPosition="before"
        name="active"
        [checked]="email.status"
        color="primary"
        (change)="onStatusChange($event.checked, email)"
        >
      </mat-slide-toggle>
    </ng-template>

    <ng-template appTableCell="_actions" let-email>
      <div class="actions-column">
        <a id="wallet-emails-tab-btn-delete-{{email.id}}" (click)="handleDeleteEmailAlert(email)">
          <em class="far fa-trash-alt"></em>
        </a>
        <a id="wallet-emails-tab-btn-edit-{{email.id}}" (click)="handleEditEmailAlert(email)">
          <em class="fas fa-pencil-alt"></em>
        </a>
      </div>
    </ng-template>
  </app-generic-table>
</div>
